// ============默认菜单 不需要登录的 ============
import loginIndex from '../modules/loginIndex'
import admin from '../modules/admin'
import agreement from '../modules/agreement'
import agreementV2 from '../modules/agreementV2'
import serviceAgreement from '../modules/serviceAgreement'
import root from '../modules/root'
import paymentLink from '../modules/paymentLink'
import authFail from '../modules/authFail'

export default [
	...root,
	...loginIndex,
	...admin,
	...agreement,
	...agreementV2,
	...serviceAgreement,
	...paymentLink,
	...authFail
]
